import {
  FETCH_DEVICES,
  SET_DEVICES,
  SET_DEVICES_FAILURE,
  CLEAR_DEVICES,
  FETCH_DEVICE_DETAILS,
  SET_DEVICE_DETAILS,
  SET_DEVICE_DETAILS_FAILURE,
  CLEAR_DEVICE_DETAILS,
  UPDATE_DEVICE_STATUS,
  SET_DEVICE_STATUS_SUCCESS,
  SET_DEVICE_STATUS_FAILURE,
  UPDATE_DEVICE_PROJECT,
  SET_DEVICE_PROJECT_SUCCESS,
  SET_DEVICE_PROJECT_FAILURE,
  BULK_UPDATE_DEVICES,
  SET_BULK_UPDATE_SUCCESS,
  SET_BULK_UPDATE_FAILURE,
  FETCH_DEVICE_FILTERS,
  SET_DEVICE_FILTERS,
  SET_DEVICE_FILTERS_FAILURE,
  FETCH_DEVICE_STATS,
  SET_DEVICE_STATS,
  SET_DEVICE_STATS_FAILURE,
  DEVICE_REBOOT,
  SET_DEVICE_REBOOT_SUCCESS,
  SET_DEVICE_REBOOT_FAILURE,
  DEVICE_FIRMWARE_UPDATE,
  SET_DEVICE_FIRMWARE_UPDATE_SUCCESS,
  SET_DEVICE_FIRMWARE_UPDATE_FAILURE,
  FETCH_DEVICE_LOGS,
  SET_DEVICE_LOGS,
  SET_DEVICE_LOGS_FAILURE,
  CLEAR_DEVICE_LOGS,
  // Project List Actions
  FETCH_PROJECT_LIST,
  SET_PROJECT_LIST,
  SET_PROJECT_LIST_FAILURE,
  FETCH_DEVICE_PROJECT_LIST,
  SET_DEVICE_PROJECT_LIST,
  SET_DEVICE_PROJECT_LIST_FAILURE,
  // Communication Check Actions
  CHECK_COMMUNICATION,
  SET_COMMUNICATION_SUCCESS,
  SET_COMMUNICATION_FAILURE,
  SET_COMMUNICATION_RESPONSE_TIME,
  START_COMMUNICATION_TIMER,
  // Get All Devices Actions
  GET_ALL_DEVICES,
  SET_ALL_DEVICES_SUCCESS,
  SET_ALL_DEVICES_FAILURE,
  // Device Time Management Actions
  SET_DEVICE_TIME_DETAILS,
  GET_DEVICE_TIME_DETAILS,
  SET_DEVICE_TIME_SUCCESS,
  SET_DEVICE_TIME_FAILURE,
  SET_DEVICE_TIME_SET_SUCCESS,
  SET_DEVICE_TIME_SET_FAILURE,
  // Device Logs Management Actions
  CHECK_NUMBER_LOGS,
  ERASE_LOGS,
  SET_LOGS_SUCCESS,
  SET_LOGS_FAILURE,
  SET_ERASE_LOGS_SUCCESS,
  SET_ERASE_LOGS_FAILURE,
  // Weld Parameters Actions
  WELDPARAMS,
  LOCATION,
  PASSWORD_PROTECTION,
  SET_WELD_PARAMS_SUCCESS,
  SET_WELD_PARAMS_FAILURE,
  SET_LOCATION_SUCCESS,
  SET_LOCATION_FAILURE,
  // Device Status Update Actions
  UPDATE_DEVICE_OPERATION_STATUS,
  SET_DEVICE_OPERATION_STATUS_SUCCESS,
  SET_DEVICE_OPERATION_STATUS_FAILURE,
  // Clear Operations Data
  CLEAR_DEVICE_OPERATIONS_DATA,
  // Firmware Update Device Tracking
  ADD_FIRMWARE_UPDATE_DEVICE,
  REMOVE_FIRMWARE_UPDATE_DEVICE,
  CLEAR_FIRMWARE_UPDATE_DEVICES,
  // Firmware Update Polling
  START_FIRMWARE_UPDATE_POLLING,
  STOP_FIRMWARE_UPDATE_POLLING,
  UPDATE_FIRMWARE_UPDATE_PROGRESS,
  SET_FIRMWARE_UPDATE_PROGRESS,
  CLEAR_FIRMWARE_UPDATE_PROGRESS
} from './types';

const initialState = {
  // Device List
  devices: [],
  devicesLoading: false,
  devicesError: null,
  
  // Device Details
  deviceDetails: {},
  deviceDetailsLoading: false,
  deviceDetailsError: null,
  
  // Device Status Update
  statusUpdateLoading: false,
  statusUpdateError: null,
  statusUpdateSuccess: false,
  
  // Device Project Assignment
  projectUpdateLoading: false,
  projectUpdateError: null,
  projectUpdateSuccess: false,
  
  // Bulk Device Updates
  bulkUpdateLoading: false,
  bulkUpdateError: null,
  bulkUpdateSuccess: false,
  
  // Device Filters
  deviceFilters: {
    statuses: [],
    types: [],
    projects: []
  },
  filtersLoading: false,
  filtersError: null,
  
  // Device Stats
  deviceStats: {
    total: 0,
    connected: 0,
    disconnected: 0,
    communicating: 0,
    commissioned: 0,
    decommissioned: 0
  },
  statsLoading: false,
  statsError: null,
  
  // Device Reboot
  rebootLoading: false,
  rebootError: null,
  rebootSuccess: false,
  
  // Device Firmware Update
  firmwareUpdateLoading: false,
  firmwareUpdateError: null,
  firmwareUpdateSuccess: false,
  
  // Device Logs
  deviceLogs: {},
  logsLoading: false,
  logsError: null,
  
  // Communication Check
  communicationCheck: {},
  communicationLoading: false,
  communicationError: null,
  communicationResponseTime: {},
  communicationTimers: {},
  
  // Get All Devices
  allDevicesData: {},
  allDevicesLoading: false,
  allDevicesError: null,
  
  // Device Time Management
  deviceTime: {},
  timeLoading: false,
  timeError: null,
  
  // Device Logs Management
  logsManagement: {},
  logsManagementLoading: false,
  logsManagementError: null,
  
  // Erase Logs Management
  eraseLogs: {},
  eraseLogsLoading: false,
  eraseLogsError: null,
  
  // Weld Parameters
  weldParams: {},
  weldParamsLoading: false,
  weldParamsError: null,
  
  // Location
  location: {},
  locationLoading: false,
  locationError: null,
  
  // Device Operation Status
  operationStatusUpdate: {},
  operationStatusLoading: false,
  operationStatusError: null,
  
  // Project List
  projectList: [],
  projectListLoading: false,
  projectListError: null,
  deviceProjectList: [],
  deviceProjectListLoading: false,
  deviceProjectListError: null,

  // Firmware Update Device Tracking
  firmwareUpdateDevice: [],
  
  // Firmware Update Progress
  firmwareUpdateProgress: {},
};

const deviceReducer = (state = initialState, action) => {
  switch (action.type) {
    // Device List Cases
    case FETCH_DEVICES:
      return {
        ...state,
        devicesLoading: true,
        devicesError: null
      };

    case SET_DEVICES:
      return {
        ...state,
        devices: Array.isArray(action.devices) ? action.devices : [],
        devicesLoading: false,
        devicesError: null
      };

    case SET_DEVICES_FAILURE:
      return {
        ...state,
        devicesLoading: false,
        devicesError: action.error
      };

    case CLEAR_DEVICES:
      return {
        ...state,
        devices: [],
        devicesError: null
      };

    // Device Details Cases
    case FETCH_DEVICE_DETAILS:
      return {
        ...state,
        deviceDetailsLoading: true,
        deviceDetailsError: null
      };

    case SET_DEVICE_DETAILS:
      return {
        ...state,
        deviceDetails: {
          ...state.deviceDetails,
          [action.deviceDetails.id]: action.deviceDetails
        },
        deviceDetailsLoading: false,
        deviceDetailsError: null
      };

    case SET_DEVICE_DETAILS_FAILURE:
      return {
        ...state,
        deviceDetailsLoading: false,
        deviceDetailsError: action.error
      };

    case CLEAR_DEVICE_DETAILS:
      return {
        ...state,
        deviceDetails: {},
        deviceDetailsError: null
      };

    // Device Status Update Cases
    case UPDATE_DEVICE_STATUS:
      return {
        ...state,
        statusUpdateLoading: true,
        statusUpdateError: null,
        statusUpdateSuccess: false
      };

    case SET_DEVICE_STATUS_SUCCESS:
      return {
        ...state,
        devices: state.devices.map(device => 
          device.id === action.deviceId
            ? { ...device, status: action.status }
            : device
        ),
        statusUpdateLoading: false,
        statusUpdateError: null,
        statusUpdateSuccess: true
      };

    case SET_DEVICE_STATUS_FAILURE:
      return {
        ...state,
        statusUpdateLoading: false,
        statusUpdateError: action.error,
        statusUpdateSuccess: false
      };

    // Device Project Assignment Cases
    case UPDATE_DEVICE_PROJECT:
      return {
        ...state,
        projectUpdateLoading: true,
        projectUpdateError: null,
        projectUpdateSuccess: false
      };

    case SET_DEVICE_PROJECT_SUCCESS:
      return {
        ...state,
        devices: state.devices.map(device => 
          device.id === action.deviceId
            ? { ...device, project: action.project }
            : device
        ),
        projectUpdateLoading: false,
        projectUpdateError: null,
        projectUpdateSuccess: true
      };

    case SET_DEVICE_PROJECT_FAILURE:
      return {
        ...state,
        projectUpdateLoading: false,
        projectUpdateError: action.error,
        projectUpdateSuccess: false
      };

    // Bulk Device Updates Cases
    case BULK_UPDATE_DEVICES:
      return {
        ...state,
        bulkUpdateLoading: true,
        bulkUpdateError: null,
        bulkUpdateSuccess: false
      };

    case SET_BULK_UPDATE_SUCCESS:
      return {
        ...state,
        devices: action.updatedDevices,
        bulkUpdateLoading: false,
        bulkUpdateError: null,
        bulkUpdateSuccess: true
      };

    case SET_BULK_UPDATE_FAILURE:
      return {
        ...state,
        bulkUpdateLoading: false,
        bulkUpdateError: action.error,
        bulkUpdateSuccess: false
      };

    // Device Filters Cases
    case FETCH_DEVICE_FILTERS:
      return {
        ...state,
        filtersLoading: true,
        filtersError: null
      };

    case SET_DEVICE_FILTERS:
      return {
        ...state,
        deviceFilters: action.filters,
        filtersLoading: false,
        filtersError: null
      };

    case SET_DEVICE_FILTERS_FAILURE:
      return {
        ...state,
        filtersLoading: false,
        filtersError: action.error
      };

    // Device Stats Cases
    case FETCH_DEVICE_STATS:
      return {
        ...state,
        statsLoading: true,
        statsError: null
      };

    case SET_DEVICE_STATS:
      return {
        ...state,
        deviceStats: action.stats,
        statsLoading: false,
        statsError: null
      };

    case SET_DEVICE_STATS_FAILURE:
      return {
        ...state,
        statsLoading: false,
        statsError: action.error
      };

    // Device Reboot Cases
    case DEVICE_REBOOT:
      return {
        ...state,
        rebootLoading: true,
        rebootError: null,
        rebootSuccess: false
      };

    case SET_DEVICE_REBOOT_SUCCESS:
      return {
        ...state,
        devices: state.devices.map(device => 
          device.id === action.deviceId
            ? { ...device, lastSeen: new Date().toISOString() }
            : device
        ),
        rebootLoading: false,
        rebootError: null,
        rebootSuccess: true
      };

    case SET_DEVICE_REBOOT_FAILURE:
      return {
        ...state,
        rebootLoading: false,
        rebootError: action.error,
        rebootSuccess: false
      };

    // Device Firmware Update Cases
    case DEVICE_FIRMWARE_UPDATE:
      return {
        ...state,
        firmwareUpdateLoading: true,
        firmwareUpdateError: null,
        firmwareUpdateSuccess: false
      };

    case SET_DEVICE_FIRMWARE_UPDATE_SUCCESS:
      return {
        ...state,
        devices: state.devices.map(device => 
          device.id === action.deviceId
            ? { 
                ...device, 
                metadata: { 
                  ...device.metadata, 
                  firmware: action.firmwareVersion 
                } 
              }
            : device
        ),
        firmwareUpdateLoading: false,
        firmwareUpdateError: null,
        firmwareUpdateSuccess: true
      };

    case SET_DEVICE_FIRMWARE_UPDATE_FAILURE:
      return {
        ...state,
        firmwareUpdateLoading: false,
        firmwareUpdateError: action.error,
        firmwareUpdateSuccess: false
      };

    // Device Logs Cases
    case FETCH_DEVICE_LOGS:
      return {
        ...state,
        logsLoading: true,
        logsError: null
      };

    case SET_DEVICE_LOGS:
      return {
        ...state,
        deviceLogs: {
          ...state.deviceLogs,
          [action.deviceId]: action.logs
        },
        logsLoading: false,
        logsError: null
      };

    case SET_DEVICE_LOGS_FAILURE:
      return {
        ...state,
        logsLoading: false,
        logsError: action.error
      };

    case CLEAR_DEVICE_LOGS:
      return {
        ...state,
        deviceLogs: {},
        logsError: null
      };

    case CLEAR_DEVICE_OPERATIONS_DATA:
      return {
        ...state,
        // Clear communication data
        communicationCheck: {},
        communicationLoading: false,
        communicationError: null,
        // Clear device time data
        deviceTime: {},
        timeLoading: false,
        timeError: null,
        // Clear logs management data
        logsManagement: {},
        logsManagementLoading: false,
        logsManagementError: null,
        // Clear erase logs data
        eraseLogs: {},
        eraseLogsLoading: false,
        eraseLogsError: null,
        // Clear weld params data
        weldParams: {},
        weldParamsLoading: false,
        weldParamsError: null,
        // Clear location data
        location: {},
        locationLoading: false,
        locationError: null,
        // Clear operation status data
        operationStatusUpdate: {},
        operationStatusLoading: false,
        operationStatusError: null
      };

    // Communication Check Cases
    case CHECK_COMMUNICATION:
      return {
        ...state,
        communicationLoading: true,
        communicationError: null
      };

    case SET_COMMUNICATION_SUCCESS:
      return {
        ...state,
        communicationCheck: {
          ...state.communicationCheck,
          [action.deviceId]: action.communicationData
        },
        communicationLoading: false,
        communicationError: null
      };

    case START_COMMUNICATION_TIMER:
      return {
        ...state,
        communicationTimers: {
          ...state.communicationTimers,
          [action.deviceId]: action.startTime
        }
      };

    case SET_COMMUNICATION_RESPONSE_TIME:
      return {
        ...state,
        communicationResponseTime: {
          ...state.communicationResponseTime,
          [action.deviceId]: action.responseTime
        },
        // Clear the timer after setting response time
        communicationTimers: {
          ...state.communicationTimers,
          [action.deviceId]: null
        }
      };

    case SET_COMMUNICATION_FAILURE:
      return {
        ...state,
        communicationLoading: false,
        communicationError: action.error
      };

    // Get All Devices Cases
    case GET_ALL_DEVICES:
      return {
        ...state,
        allDevicesLoading: true,
        allDevicesError: null
      };

    case SET_ALL_DEVICES_SUCCESS:
      return {
        ...state,
        allDevicesData: {
          ...state.allDevicesData,
          [action.deviceId]: action.data
        },
        allDevicesLoading: false,
        allDevicesError: null
      };

    case SET_ALL_DEVICES_FAILURE:
      return {
        ...state,
        allDevicesLoading: false,
        allDevicesError: action.error
      };

    // Device Time Management Cases
    case SET_DEVICE_TIME_DETAILS:
      return {
        ...state,
        setTimeLoading: true,
        setTimeError: null
      };
    
    case GET_DEVICE_TIME_DETAILS:
      return {
        ...state,
        timeLoading: true,
        timeError: null
      };

    case SET_DEVICE_TIME_SUCCESS:
      return {
        ...state,
        deviceTime: {
          ...state.deviceTime,
          [action.deviceId]: action.timeData
        },
        timeLoading: false,
        timeError: null
      };

    case SET_DEVICE_TIME_FAILURE:
      return {
        ...state,
        timeLoading: false,
        timeError: action.error
      };

    case SET_DEVICE_TIME_SET_SUCCESS:
      return {
        ...state,
        deviceTime: {
          ...state.deviceTime,
          [action.deviceId + '_set']: action.timeData
        },
        setTimeLoading: false,
        setTimeError: null
      };

    case SET_DEVICE_TIME_SET_FAILURE:
      return {
        ...state,
        setTimeLoading: false,
        setTimeError: action.error
      };

    // Device Logs Management Cases
    case CHECK_NUMBER_LOGS:
      return {
        ...state,
        logsManagementLoading: true,
        logsManagementError: null
      };

    case ERASE_LOGS:
      return {
        ...state,
        eraseLogsLoading: true,
        eraseLogsError: null
      };

    case SET_LOGS_SUCCESS:
      return {
        ...state,
        logsManagement: {
          ...state.logsManagement,
          [action.deviceId]: action.logsData
        },
        logsManagementLoading: false,
        logsManagementError: null
      };

    case SET_LOGS_FAILURE:
      return {
        ...state,
        logsManagementLoading: false,
        logsManagementError: action.error
      };

    case SET_ERASE_LOGS_SUCCESS:
      return {
        ...state,
        eraseLogs: {
          ...state.eraseLogs,
          [action.deviceId]: action.eraseData
        },
        eraseLogsLoading: false,
        eraseLogsError: null
      };

    case SET_ERASE_LOGS_FAILURE:
      return {
        ...state,
        eraseLogsLoading: false,
        eraseLogsError: action.error
      };

    // Weld Parameters Cases
    case WELDPARAMS:
    case PASSWORD_PROTECTION:
      return {
        ...state,
        weldParamsLoading: true,
        weldParamsError: null
      };

    case LOCATION:
      return {
        ...state,
        locationLoading: true,
        locationError: null
      };

    case SET_WELD_PARAMS_SUCCESS:
      console.log('SET_WELD_PARAMS_SUCCESS reducer called', action.deviceId, action.weldParamsData);
      // Ensure we create a completely new object reference to trigger React re-renders
      // This is critical for React to detect state changes and trigger re-renders
      const newWeldParamsData = action.weldParamsData ? {
        ...action.weldParamsData,
        // Deep copy nested data if it exists
        data: action.weldParamsData.data ? (
          typeof action.weldParamsData.data === 'object' 
            ? { ...action.weldParamsData.data }
            : action.weldParamsData.data
        ) : action.weldParamsData.data,
        // Add timestamp to ensure unique reference on each update
        _timestamp: Date.now(),
        // Add a unique update counter to force new reference
        _updateCount: (state.weldParams[action.deviceId]?._updateCount || 0) + 1
      } : action.weldParamsData;
      
      // Create a completely new weldParams object to ensure reference change
      const newWeldParams = {
        ...state.weldParams,
        [action.deviceId]: newWeldParamsData
      };
      
      console.log('SET_WELD_PARAMS_SUCCESS - New state created with timestamp:', newWeldParamsData._timestamp);
      
      return {
        ...state,
        weldParams: newWeldParams,
        weldParamsLoading: false,
        weldParamsError: null
      };

    case SET_WELD_PARAMS_FAILURE:
      return {
        ...state,
        weldParamsLoading: false,
        weldParamsError: action.error
      };

    case SET_LOCATION_SUCCESS:
      return {
        ...state,
        location: {
          ...state.location,
          [action.deviceId]: action.locationData
        },
        locationLoading: false,
        locationError: null
      };

    case SET_LOCATION_FAILURE:
      return {
        ...state,
        locationLoading: false,
        locationError: action.error
      };

    // Device Operation Status Update Cases
    case UPDATE_DEVICE_OPERATION_STATUS:
      return {
        ...state,
        operationStatusLoading: true,
        operationStatusError: null
      };

    case SET_DEVICE_OPERATION_STATUS_SUCCESS:
      return {
        ...state,
        devices: state.devices.map(device => 
          device.id === action.deviceId
            ? { 
                ...device, 
                operationStatus: action.operationStatus,
                lastUpdated: action.lastUpdated
              }
            : device
        ),
        operationStatusUpdate: {
          ...state.operationStatusUpdate,
          [action.deviceId]: {
            operationStatus: action.operationStatus,
            lastUpdated: action.lastUpdated
          }
        },
        operationStatusLoading: false,
        operationStatusError: null
      };

    case SET_DEVICE_OPERATION_STATUS_FAILURE:
      return {
        ...state,
        operationStatusLoading: false,
        operationStatusError: action.error
      };

    // Project List Cases
    case FETCH_PROJECT_LIST:
      return {
        ...state,
        projectListLoading: true,
        projectListError: null
      };

    case SET_PROJECT_LIST:
      return {
        ...state,
        projectList: Array.isArray(action.projectList) ? action.projectList : [],
        projectListLoading: false,
        projectListError: null
      };

    case SET_PROJECT_LIST_FAILURE:
      return {
        ...state,
        projectListLoading: false,
        projectListError: action.error
      };

    case FETCH_DEVICE_PROJECT_LIST:
      return {
        ...state,
        deviceProjectList: [],
        deviceProjectListLoading: true,
        deviceProjectListError: null
      };

    case SET_DEVICE_PROJECT_LIST:
      return {
        ...state,
        deviceProjectList: Array.isArray(action.projectList) ? action.projectList : [],
        deviceProjectListLoading: false,
        deviceProjectListError: null
      };

    case SET_DEVICE_PROJECT_LIST_FAILURE:
      return {
        ...state,
        deviceProjectList: [],
        deviceProjectListLoading: false,
        deviceProjectListError: action.error
      };

    // Firmware Update Device Tracking Cases
    case ADD_FIRMWARE_UPDATE_DEVICE:
      // Add device ID to array if not already present
      if (state.firmwareUpdateDevice.includes(action.deviceId)) {
        return state; // Already in array, no change needed
      }
      return {
        ...state,
        firmwareUpdateDevice: [...state.firmwareUpdateDevice, action.deviceId]
      };

    case REMOVE_FIRMWARE_UPDATE_DEVICE:
      // Remove device ID from array
      return {
        ...state,
        firmwareUpdateDevice: state.firmwareUpdateDevice.filter(id => id !== action.deviceId)
      };

    case CLEAR_FIRMWARE_UPDATE_DEVICES:
      return {
        ...state,
        firmwareUpdateDevice: []
      };

    // Firmware Update Progress Cases
    case START_FIRMWARE_UPDATE_POLLING:
      return {
        ...state,
        firmwareUpdateProgress: {
          ...state.firmwareUpdateProgress,
          [action.deviceId]: {
            deviceId: action.deviceId,
            deviceData: action.deviceData,
            status: 'initiated',
            startTime: new Date().toISOString(),
            firmwareVersion: null,
            error: null
          }
        }
      };

    case STOP_FIRMWARE_UPDATE_POLLING:
      const { [action.deviceId]: removed, ...remainingProgress } = state.firmwareUpdateProgress;
      return {
        ...state,
        firmwareUpdateProgress: remainingProgress
      };

    case UPDATE_FIRMWARE_UPDATE_PROGRESS:
      return {
        ...state,
        firmwareUpdateProgress: {
          ...state.firmwareUpdateProgress,
          [action.deviceId]: {
            ...state.firmwareUpdateProgress[action.deviceId],
            ...action.progressData
          }
        }
      };

    case SET_FIRMWARE_UPDATE_PROGRESS:
      return {
        ...state,
        firmwareUpdateProgress: {
          ...state.firmwareUpdateProgress,
          [action.deviceId]: action.progressData
        }
      };

    case CLEAR_FIRMWARE_UPDATE_PROGRESS:
      const { [action.deviceId]: cleared, ...restProgress } = state.firmwareUpdateProgress;
      return {
        ...state,
        firmwareUpdateProgress: restProgress
      };

    default:
      return state;
  }
};

export default deviceReducer;
